import { NestableListProps } from '.';

// This object should contain a mock value for each required prop of this component
export const requiredProps: NestableListProps = {
  items: [
    {
      id: '0',
      options: [{ value: 'Node 0' }],
      draggable: true,
      children: [
        {
          id: '1',
          options: [{ value: 'Node 0 child' }],
          draggable: true,
          dragHandleProps: { 'aria-label': 'Drag handle for node 0 child' },
        },
      ],
      dragHandleProps: {
        'aria-label': 'Drag handle for node 0',
      },
    },
  ],
};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as NestableListProps,
  },
];

export const testkitTests = [...sharedTests];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
